
import React, { lazy, Suspense } from 'react';
import type { RouteObject } from 'react-router-dom';

const PrimeSalesPage = lazy(() => import('../pages/prime-sales/page'));
const FormPanelPage = lazy(() => import('../pages/form-panel/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: (
      <Suspense fallback={null}>
        <PrimeSalesPage />
      </Suspense>
    ),
  },
  {
    path: '/form-panel',
    element: (
      <Suspense fallback={null}>
        <FormPanelPage />
      </Suspense>
    ),
  },
  {
    path: '*',
    element: (
      <Suspense fallback={null}>
        <NotFound />
      </Suspense>
    ),
  },
];

export default routes;
